import clsx from 'clsx';
import { CSSProperties, ReactNode } from 'react';

import style from './BorderContainer.module.css';

export interface BorderContainerProps {
  topPadding?: string;
  fullWidth?: boolean;
  borderHidden?: boolean;
  children?: ReactNode | ReactNode[];
}

export const BorderContainer = ({ topPadding, fullWidth, borderHidden, children }: BorderContainerProps) => {
  return (
    <div
      className={clsx(style.root, { [style.fullWidth]: fullWidth, [style.borderHidden]: borderHidden })}
      style={topPadding ? ({ '--border-container-top-padding': topPadding } as CSSProperties) : {}}
    >
      {children}
    </div>
  );
};
